import { rateMealsModalAtom } from 'src/atoms/modals/rateMealsModal.atom'
import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'
import { useSetAtom } from 'jotai'

interface RateMealsStepProps {
  completed: boolean
  enabled: boolean
}

export function RateMealsStep({
  completed,
  enabled
}: Readonly<RateMealsStepProps>) {
  const setRateMealsModal = useSetAtom(rateMealsModalAtom)

  const handleRateMeals = () => {
    setRateMealsModal({
      isOpen: true
    })
  }

  return (
    <OnboardingStep
      title="Rate your meals"
      description="How was your first order? Let us know so we can serve up better recommendations."
      status={getStepStatus(completed, enabled)}
      icon="star"
      tag={enabled ? undefined : 'Available after your first delivery'}
      action={{
        label: 'Rate Meals',
        onClick: handleRateMeals
      }}
    />
  )
}
